"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailsListBasicList = exports.DetailsList = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1mudung-0"
})(["&&{> *{margin:24px 0;}}"]);

var StyledIcon = (0, _styledComponents["default"])(_baseReactComponents.Icon).withConfig({
  displayName: "StyledIcon",
  componentId: "sc-1mudung-1"
})(["fill:", ";margin-right:8px;"], function (_ref) {
  var color = _ref.color;
  return color;
});

var KeyValueList = _styledComponents["default"].dl.withConfig({
  displayName: "KeyValueList",
  componentId: "sc-1mudung-2"
})(["width:100%;border:1px solid ", ";border-radius:10px;overflow:hidden;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.scuttleGray200;
});

var BasicList = _styledComponents["default"].ul.withConfig({
  displayName: "BasicList",
  componentId: "sc-1mudung-3"
})(["width:100%;border:1px solid ", ";border-radius:10px;overflow:hidden;padding:0;margin:0;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.scuttleGray200;
});

var KeyValueRow = _styledComponents["default"].div.withConfig({
  displayName: "KeyValueRow",
  componentId: "sc-1mudung-4"
})(["display:flex;flex-direction:row;align-items:flex-start;justify-content:flex-start;&:nth-child(odd){background:", ";}& > dt{flex:0 0 25%;min-width:100px;padding:16px 0 16px 16px;margin:0;}& > dd{flex:1 1 75%;padding:16px;margin:0;display:flex;flex-direction:row;align-items:flex-start;justify-content:flex-start;& > ", "{flex:0 0 auto;}& > ", "{flex:1 1 0;}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.bubbleBlue100;
}, StyledIcon, _baseReactComponents.Copy);

var BasicRow = _styledComponents["default"].li.withConfig({
  displayName: "BasicRow",
  componentId: "sc-1mudung-5"
})(["list-style:none;margin:0;padding:16px;display:flex;flex-direction:row;align-items:flex-start;justify-content:flex-start;&:nth-child(odd){background:", ";}& > ", "{flex:0 0 auto;}& > ", "{flex:1 1 0;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.bubbleBlue100;
}, StyledIcon, _baseReactComponents.Copy);

var DetailsListBasicList = function DetailsListBasicList(_ref6) {
  var items = _ref6.items;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(BasicList, {
    children: items.map(function (_ref7, i) {
      var _icon$color;

      var description = _ref7.description,
          _ref7$icon = _ref7.icon,
          icon = _ref7$icon === void 0 ? {} : _ref7$icon;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(BasicRow, {
        children: [icon.icon != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
          name: icon.icon,
          color: (_icon$color = icon.color) !== null && _icon$color !== void 0 ? _icon$color : null
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
          className: "js-private",
          "data-heap-redact-text": "true",
          children: description
        })]
      }, i);
    })
  });
};

exports.DetailsListBasicList = DetailsListBasicList;

var DetailsListComponent = function DetailsListComponent(_ref8) {
  var _ref8$items = _ref8.items,
      items = _ref8$items === void 0 ? [] : _ref8$items;
  var twoColumn = items.every(function (_ref9) {
    var title = _ref9.title;
    return title != null && !!title;
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Wrapper, {
    children: twoColumn ? /*#__PURE__*/(0, _jsxRuntime.jsx)(KeyValueList, {
      children: items.map(function (_ref10, i) {
        var _icon$color2;

        var title = _ref10.title,
            description = _ref10.description,
            _ref10$icon = _ref10.icon,
            icon = _ref10$icon === void 0 ? {} : _ref10$icon;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(KeyValueRow, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("dt", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
              bold: true,
              children: title
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("dd", {
            children: [icon.icon != null && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
              name: icon.icon,
              color: (_icon$color2 = icon.color) !== null && _icon$color2 !== void 0 ? _icon$color2 : null
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Copy, {
              className: "js-private",
              "data-heap-redact-text": "true",
              children: description
            })]
          })]
        }, i);
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(DetailsListBasicList, {
      items: items
    })
  });
};

var DetailsList = (0, _styledComponents["default"])(DetailsListComponent).withConfig({
  displayName: "DetailsList",
  componentId: "sc-1mudung-6"
})([""]);
exports.DetailsList = DetailsList;
//# sourceMappingURL=details-list.js.map